module.exports = __webpack_public_path__ + "static/storylines-ec50489836c0608a582f053729673424.png";